// extracted by mini-css-extract-plugin
module.exports = {"itemTitle":"TitleWithIcon_itemTitle__m55Da"};